"use strict";

exports.__esModule = true;
exports.default = {
  birthDate: null,
  businessPhone: null,
  corporateDocument: null,
  corporateName: null,
  document: null,
  email: null,
  firstName: null,
  gender: null,
  homePhone: null,
  lastName: null,
  stateRegistration: null,
  tradeName: null,
  isCorporate: false
};
module.exports = exports["default"];